/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CbtAssessmentResponse } from '../models/CbtAssessmentResponse';
import type { CreateCbtAssessmentRequest } from '../models/CreateCbtAssessmentRequest';
import type { Page_CbtAssessmentSummaryResponse_ } from '../models/Page_CbtAssessmentSummaryResponse_';
import type { UpdateCbtAssessmentDetailsRequest } from '../models/UpdateCbtAssessmentDetailsRequest';
import type { UpdateCbtAssessmentQuestionsRequest } from '../models/UpdateCbtAssessmentQuestionsRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CbtAssessmentRestControllerService {
  /**
   * list
   * @returns Page_CbtAssessmentSummaryResponse_ OK
   * @throws ApiError
   */
  public static listUsingGet({
    dateFrom,
    dateTo,
    limit,
    offset,
    search,
    type,
  }: {
    /**
     * date-from
     */
    dateFrom?: string;
    /**
     * date-to
     */
    dateTo?: string;
    limit?: number;
    offset?: number;
    /**
     * search
     */
    search?: string;
    /**
     * type
     */
    type?: 'ASSIGNMENT' | 'QUIZ';
  }): CancelablePromise<Page_CbtAssessmentSummaryResponse_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cbt/assessments',
      query: {
        'date-from': dateFrom,
        'date-to': dateTo,
        limit: limit,
        offset: offset,
        search: search,
        type: type,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * create
   * @returns CbtAssessmentResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static createUsingPost2({
    request,
  }: {
    /**
     * request
     */
    request: CreateCbtAssessmentRequest;
  }): CancelablePromise<CbtAssessmentResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/cbt/assessments',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateDetails
   * @returns CbtAssessmentResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateDetailsUsingPut({
    request,
  }: {
    /**
     * request
     */
    request: UpdateCbtAssessmentDetailsRequest;
  }): CancelablePromise<CbtAssessmentResponse | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/cbt/assessments/details',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateQuestions
   * @returns CbtAssessmentResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateQuestionsUsingPut({
    request,
  }: {
    /**
     * request
     */
    request: UpdateCbtAssessmentQuestionsRequest;
  }): CancelablePromise<CbtAssessmentResponse | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/cbt/assessments/questions',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getOne
   * @returns CbtAssessmentResponse OK
   * @throws ApiError
   */
  public static getOneUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<CbtAssessmentResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/cbt/assessments/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * delete
   * @returns any OK
   * @throws ApiError
   */
  public static deleteUsingDelete1({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/cbt/assessments/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * publish
   * @returns CbtAssessmentResponse OK
   * @returns any Created
   * @throws ApiError
   */
  public static publishUsingPost({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<CbtAssessmentResponse | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/cbt/assessments/{id}/publish',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
